<template>
  <div
    :class="[
      'gt-sm',
      collapsible && isCollapsed
        ? 'resumen-sidebar--collapsed'
        : 'col-12 col-md-4 bg-grey-1 q-pa-md resumen-sidebar--expanded',
    ]"
  >
    <!-- Botón de colapso en el borde izquierdo -->
    <q-btn
      v-if="collapsible"
      flat dense
      :icon="isCollapsed ? 'chevron_left' : 'chevron_right'"
      size="sm"
      color="grey-6"
      class="resumen-toggle-btn"
      @click="isCollapsed = !isCollapsed"
    >
      <q-tooltip :anchor="isCollapsed ? 'middle right' : 'middle left'" self="middle left">
        {{ isCollapsed ? 'Mostrar resumen' : 'Ocultar resumen' }}
      </q-tooltip>
    </q-btn>

    <!-- Contenido del resumen (oculto cuando colapsado) -->
    <div v-if="!isCollapsed || !collapsible" class="sticky-summary">
      <!-- Slot para contenido personalizado al inicio -->
      <slot name="header" />

      <q-card flat bordered class="summary-card">
        <q-card-section class="bg-primary text-white">
          <div class="text-h6">
            <q-icon name="receipt_long" class="q-mr-sm" />
            Resumen
          </div>
        </q-card-section>

        <q-separator />

        <q-card-section>
          <!-- Información del producto -->
          <div class="summary-row">
            <span class="text-grey-7">Producto:</span>
            <span class="text-weight-medium">{{ producto.productoID }}</span>
          </div>
          <div class="summary-row">
            <span class="text-grey-7">Descripción:</span>
            <span class="text-caption">{{ producto.productoDesc }}</span>
          </div>
          <div class="summary-row">
            <span class="text-grey-7">Plazo Matriz:</span>
            <span class="text-caption">{{ parseInt(producto.plazo) }} días</span>
          </div>

          <q-separator class="q-my-md" />

          <!-- Secciones tipo-específicas -->
          <!-- PANEL -->
          <template v-if="type === 'panel'">
            <div class="summary-row">
              <span class="text-grey-7">Ancho:</span>
              <span>{{ ancho }} m</span>
            </div>
            <div class="summary-row">
              <span class="text-grey-7">Largo pieza:</span>
              <span>{{ form.largo_pieza || 0 }} m</span>
            </div>
            <div class="summary-row">
              <span class="text-grey-7">Piezas:</span>
              <span>{{ numberFormat(form.cantidad_piezas || 0,true) }}</span>
            </div>
            <div class="summary-row text-weight-bold">
              <span class="text-grey-8">Total m²:</span>
              <span class="text-primary">{{ numberFormat(form.cantidad || 0,true) }} m²</span>
            </div>
            <q-separator class="q-my-md" />
            <div class="summary-row">
              <span class="text-grey-7">Precio Unit.:</span>
              <span>{{ numberFormat(form.precio_unitario) }}</span>
            </div>
            <div class="summary-row">
              <span class="text-negative">Precio Unit. Descuento:</span>
              <span class="text-negative">{{ numberFormat(descuentoComercialUnitario) }}
              ({{ totalDescuentosPorcentaje }}%)</span>
            </div>
          </template>

          <!-- CÁMARA -->
          <template v-if="type === 'camara'">
            <div class="summary-row">
              <span class="text-grey-7">Cantidad:</span>
              <span>{{ form.cantidad }} cámara(s)</span>
            </div>
            <q-separator class="q-my-md" />
            <template v-if="form.largo || form.ancho || form.alto">
              <div class="text-subtitle2 text-grey-8 q-mb-sm">Dimensiones</div>
              <div class="summary-row">
                <span class="text-grey-7">Largo:</span>
                <span>{{ form.largo || 0 }} m</span>
              </div>
              <div class="summary-row">
                <span class="text-grey-7">Ancho:</span>
                <span>{{ form.ancho || 0 }} m</span>
              </div>
              <div class="summary-row">
                <span class="text-grey-7">Alto:</span>
                <span>{{ form.alto || 0 }} m</span>
              </div>
              <div class="summary-row text-weight-medium">
                <span class="text-grey-8">Volumen:</span>
                <span class="text-primary">{{ form.m3 || 0 }} m³</span>
              </div>
              <q-separator class="q-my-md" />
            </template>
            <div class="summary-row">
              <span class="text-grey-7">Total M²:</span>
              <span>{{ numberFormat(totalM2, true) }} m²</span>
            </div>
            <div class="summary-row text-weight-medium">
              <span class="text-grey-8">Subtotal Paneles:</span>
              <span class="text-primary">{{ numberFormat(totalPanelesSubtotal) }}</span>
            </div>
            <!-- <div class="summary-row">
              <span class="text-grey-7">Selladores:</span>
              <span>{{ numberFormat(form.selladores) }}</span>
            </div> -->
            <div class="summary-row text-weight-medium">
              <span class="text-grey-8">Productos / Accesorios Opcionales:</span>
              <span class="text-primary">{{ numberFormat(totalOtrosProductos) }}</span>
            </div>
            <div class="summary-row" v-if="totalPerfilerias">
              <span class="text-grey-7"> Subtotal Perfilería, Consumibles y Accesorios de fijación:</span>
              <span class="text-weight-medium">{{ numberFormat(totalPerfilerias) }}</span>
            </div>
            <template v-if="puertasCount > 0">
              <div class="summary-row text-weight-medium">
                <span class="text-grey-8">Subtotal Puertas:</span>
                <span class="text-primary">{{ numberFormat(totalPuertas) }}</span>
              </div>
            </template>
            <div class="summary-row text-h6 text-weight-medium" v-if="form.cantidad > 1">
              <span class="text-grey-8">Precio Unitario:</span>
              <span class="text-grey-8">{{ numberFormat(precioUnitario) }}</span>
            </div>
          </template>

          <!-- PUERTA, ACCESORIO, EQUIPO (similares) -->
          <template v-if="type === 'puerta' || type === 'equipo' || type === 'perfil' || type === 'accesorio'">
            <!-- Configuración específica de PUERTA -->
            <template v-if="type === 'puerta' && (form.espesor_panel || form.espesor_piso || form.apertura || form.temperatura)">
              <div class="text-subtitle2 text-grey-8 q-mb-sm">Configuración</div>
              <div class="summary-row" v-if="form.espesor_panel">
                <span class="text-grey-7">Espesor Panel:</span>
                <span>{{ form.espesor_panel }} mm</span>
              </div>
              <div class="summary-row" v-if="form.espesor_piso">
                <span class="text-grey-7">Espesor Piso:</span>
                <span>{{ form.espesor_piso }} mm</span>
              </div>
              <div class="summary-row" v-if="form.apertura">
                <span class="text-grey-7">Apertura:</span>
                <span class="text-capitalize">{{ form.apertura }}</span>
              </div>
              <div class="summary-row" v-if="form.temperatura">
                <span class="text-grey-7">Temperatura:</span>
                <span>{{ form.temperatura }}</span>
              </div>
              <q-separator class="q-my-md" />
            </template>

            <div class="summary-row">
              <span class="text-grey-7">Precio Unit.:</span>
              <span>{{ numberFormat(form.precio_unitario) }}</span>
            </div>
            <div class="summary-row">
              <span class="text-negative">Precio Unit. Descuento:</span>
              <span class="text-negative">{{ numberFormat(descuentoComercialUnitario) }}
              ({{ totalDescuentosPorcentaje }}%)</span>
            </div>
            <div class="summary-row">
              <span class="text-grey-7">Cantidad:</span>
              <span>{{ form.cantidad || 0 }}</span>
            </div>
            <template v-if="totalAccesorios">
              <q-separator class="q-my-md" />
              <div class="text-subtitle2 text-grey-8 q-mb-sm">Accesorios</div>
              <template v-for="(acc, index) in accesorios" :key="index">
                <div class="summary-row">
                  <span class="text-grey-7">{{ acc.producto.value ?? acc.producto.B1_DESC}}:</span>
                  <span>{{ numberFormat(acc.total) }}</span>
                </div>
              </template>
              <div class="summary-row">
                <span class="text-grey-7">Total Accesorios:</span>
                <span class="text-weight-medium">{{ totalAccesorios }}</span>
              </div>
            </template>
          </template>

          <!-- SERVICIO -->
          <template v-if="type === 'servicio'">
            <div class="summary-row">
              <span class="text-grey-7">Precio Unitario:</span>
              <span>{{ numberFormat(form.precio_unitario) }}</span>
            </div>
            <div class="summary-row">
              <span class="text-grey-7">Cantidad:</span>
              <span>{{ form.cantidad }}</span>
            </div>
            <div class="summary-row">
              <span class="text-grey-7">Subtotal:</span>
              <span>{{ numberFormat(form.subtotal) }}</span>
            </div>
            <q-separator class="q-my-md" />
          </template>



          <!-- Slot para contenido personalizado antes del total -->
          <slot name="before-total" />

          <!-- Descuentos antes del total -->
          <template v-if="totalDescuentosMonto > 0">
            <q-separator class="q-my-sm" />
            <!-- Total descuentos y desglose -->
            <!-- <div class="summary-row">
              <span>Total descuentos:</span>
              <span class="text-negative">{{ numberFormat(totalDescuentosMonto) }} ({{ totalDescuentosPorcentaje }}%)</span>
            </div> -->
            <template v-if="form.descuento_comercial > 0">
              <div class="summary-row">
                <span class="text-grey-7">Descuento Comercial:</span>
                <span class="text-negative">{{ numberFormat(descuentoComercialMonto) }} ({{ descuentoComercialPorcentajeEfectivo }}%)</span>
              </div>
            </template>
            <template v-if="form.descuento_estrategico > 0">
              <div class="summary-row">
                <span class="text-grey-7">Estratégico:</span>
                <span class="text-negative">{{ numberFormat(descuentoEstrategicoMonto) }} ({{ descuentoEstrategicoPorcentajeEfectivo }}%)</span>
              </div>
            </template>
          </template>

          <!-- Total -->
          <div class="summary-row text-h6 text-weight-bold">
            <span>Total:</span>
            <span class="text-primary">{{ numberFormat(form.total) }}</span>
          </div>
        </q-card-section>

        <q-separator />

        <q-card-section class="q-pa-sm">
          <q-linear-progress :value="validationProgress" color="positive" size="8px" rounded
            class="q-mb-xs" />
          <div class="text-caption text-center text-grey-7">
            {{ validationProgressText }}
          </div>
        </q-card-section>
      </q-card>

      <!-- Slot para contenido personalizado al final del card -->
      <slot name="after-card" />
    </div>
  </div>
</template>

<script setup>
import numberFormat from "@/helpers/numberFormat";
import { computed, ref } from "vue";

const props = defineProps({
  type: {
    type: String,
    required: true,
    validator: (value) => ['panel', 'camara', 'puerta', 'accesorio', 'equipo', 'servicio'].includes(value),
  },
  form: {
    type: Object,
    required: true,
  },
  producto: {
    type: Object,
    required: true,
  },
  validationProgress: {
    type: Number,
    required: true,
  },
  validationProgressText: {
    type: String,
    required: true,
  },
  // Props opcionales tipo-específicos
  ancho: {
    type: Number,
    default: null,
  },
  totalPaneles: {
    type: Number,
    default: null,
  },
  totalM2: {
    type: Number,
    default: null,
  },
  totalPanelesSubtotal: {
    type: Number,
    default: null,
  },
  totalOtrosProductos: {
    type: Number,
    default: null,
  },
  otrosProductosCount: {
    type: Number,
    default: null,
  },
  totalPerfilerias: {
    type: Number,
    default: null,
  },
  totalPuertas: {
    type: Number,
    default: null,
  },
  puertasCount: {
    type: Number,
    default: null,
  },
  precioUnitario: {
    type: Number,
    default: null,
  },
  accesorios: {
    type: Array,
    default: () => [],
  },
  totalAccesorios: {
    type: Number,
    default: null,
  },
  collapsible: {
    type: Boolean,
    default: false,
  },
});

const isCollapsed = ref(false);

// Subtotal base para cálculo de montos de descuentos
const subtotalBase = computed(() => {
  const s = Number((props.form && props.form.subtotal) ?? 0);
  if (s > 0) {
    return s;
  }
  const pu = Number((props.form && props.form.precio_unitario) ?? 0);
  const qty = Number((props.form && props.form.cantidad) ?? 0);
  return pu * qty;
});

// Monto de descuento comercial: aplicado sobre subtotal
const descuentoComercialMonto = computed(() => {
  const perc = Number((props.form && props.form.descuento_comercial) ?? 0);
  return subtotalBase.value * perc / 100;
});

// Descuento comercial unitario: precio unitario con el descuento comercial aplicado
const descuentoComercialUnitario = computed(() => {
  const precioUnitario = Number((props.form && props.form.precio_unitario) ?? 0);
  const perc = Number((props.form && props.form.descuento_comercial) ?? 0);
  if (precioUnitario > 0 && perc > 0) {
    return precioUnitario * (1 - perc / 100);
  }
  return precioUnitario;
});

// Monto de descuento estratégico: aplicado después del comercial
const descuentoEstrategicoMonto = computed(() => {
  const perc = Number((props.form && props.form.descuento_estrategico) ?? 0);
  const baseDespuesComercial = Math.max(0, subtotalBase.value - descuentoComercialMonto.value);
  return baseDespuesComercial * perc / 100;
});

// Total de descuentos (comercial + estratégico)
const totalDescuentosMonto = computed(() => {
  return descuentoComercialMonto.value + descuentoEstrategicoMonto.value;
});

// Porcentaje combinado efectivo de descuentos sobre el subtotal base
const totalDescuentosPorcentaje = computed(() => {
  const base = subtotalBase.value;
  if (!base || base <= 0) {
    return 0;
  }
  const pct = (totalDescuentosMonto.value / base) * 100;
  return Number(pct.toFixed(2));
});

// Porcentajes efectivos por tipo sobre el mismo subtotal base
const descuentoComercialPorcentajeEfectivo = computed(() => {
  const base = subtotalBase.value;
  if (!base || base <= 0) {
    return 0;
  }
  return Number(((descuentoComercialMonto.value / base) * 100).toFixed(2));
});

const descuentoEstrategicoPorcentajeEfectivo = computed(() => {
  const base = subtotalBase.value;
  if (!base || base <= 0) {
    return 0;
  }
  return Number(((descuentoEstrategicoMonto.value / base) * 100).toFixed(2));
});
</script>

<style lang="scss" scoped>
.sticky-summary {
  position: sticky;
  top: 20px;
  max-height: calc(90vh - 40px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.summary-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  animation: fadeIn 0.4s ease-out;
  display: flex;
  flex-direction: column;
  height: 100%;

  :deep(.q-card__section) {
    flex: 1;
    overflow-y: auto;
    overscroll-behavior: contain;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: #bbb;
      border-radius: 3px;

      &:hover {
        background: #999;
      }
    }

    // Firefox
    scrollbar-width: thin;
    scrollbar-color: #bbb #f1f1f1;
  }
}

.summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  gap: 16px;

  &:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }

  span:first-child {
    flex: 1;
  }

  span:last-child {
    text-align: right;
    word-break: break-word;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// ─── Resumen colapsable ──────────────────────────────────────────────────────
.resumen-sidebar--expanded {
  position: relative;
  transition: all 0.25s ease;
}

.resumen-sidebar--collapsed {
  position: relative;
  width: 32px;
  flex-shrink: 0;
  background: #f5f5f5;
  border-left: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 10px;
  transition: all 0.25s ease;
}

.resumen-toggle-btn {
  position: absolute;
  top: 50%;
  left: -14px;
  transform: translateY(-50%);
  z-index: 10;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  width: 28px;
  height: 28px;
  min-width: unset;
  min-height: unset;
  padding: 0;
}

@media (max-width: 1023px) {
  .sticky-summary {
    position: relative;
    top: 0;
    max-height: none;
  }
}
</style>
